const ACTIONS = {
  UPDATE: 'update',
  OPEN: 'open',
  STOP: 'stop',
  UPDATEANDRESTART: 'update-restart',
};

export default ACTIONS;
